import React from 'react';
import { Container } from 'react-bootstrap';
import './Shipping.css';

const Shipping = () => {
  return (
    <div className="shipping-page">
      <Container fluid className="shipping-container">
        <h1 className="shipping-title">Shipping</h1>

        <div className="shipping-card">
          <h2 className="shipping-card-heading">Our Shipping Policy</h2>
          <div className="shipping-card-content">
            <p>
              <strong>1. Delivery Time</strong><br />
              Orders within Tamil Nadu will be delivered within 2 working days. Orders outside Tamil Nadu will be delivered within 3–4 working days.
            </p>
            <p>
              <strong>2. Order Processing</strong><br />
              All orders are processed and dispatched as quickly as possible. Orders placed on weekends or public holidays will be processed on the next working day.
            </p>
            <p>
              <strong>3. Tracking Information</strong><br />
              Once your order is shipped, your orders can be tracked in your order details. Customers can track their shipment until delivery.
            </p>
            <p>
              <strong>4. Delays</strong><br />
              Delivery timelines may vary due to: courier delays, weather conditions, festive seasons, and operational issues beyond our control. We are not liable for delays caused by external factors once the order is shipped.
            </p>
            <p>
              <strong>5. Shipping Address</strong><br />
              Customers must provide accurate and complete delivery details. We are not responsible for orders delivered to incorrect or incomplete addresses provided by the customer.
            </p>
            <p>
              <strong>6. Shipping Charges</strong><br />
              Any applicable shipping charges will be mentioned at checkout before payment.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Shipping;
